import Slider from '../slider/slider';

export default  function topSlider() {
    const mcontainer = '[data-top-slider]';

    if (document.querySelector(mcontainer)){
        setTimeout(() => {
            if (!document.querySelector('body.DesignMode') && !document.querySelector('body.EditMode')){
                let TopSlider = new Slider(mcontainer);
                TopSlider.initAll();
            }
        }, 500);
        
    }
};